<template>
  <section>
    <ul class='navList'>
      <!-- <li class='list' v-for='item in navList' :key='item.id' @click.stop.prevent='gotoNextPage(item)' @mouseover='sleectService(item)' @mouseout='hideChild($event)'> -->
      <li class='list' v-for='item in navList' :key='item.id' @click.stop.prevent='gotoNextPage(item)' @mouseover='sleectService(item)' @mouseout='hideChild($event)'>
        <span :class='{active: item.active}'>{{item.text}}</span>
        <!-- <ul v-if='item.state && item.children.length>0'> -->
        <ul v-if='item.active && item.children.length>0'>
          <li v-for='child in item.children' :key='child.value'
              :class='{childActive: child.active}' @mouseover="selectDetail(item, child)" @click.stop='gotoPage(child)'>
            <!-- <span style='display: inline-block;width:100%;white-space:nowrap;line-height: 20px;height:20px;;font-size: 14px;'>{{child.text}}</span> -->
            {{child.text}}
          </li>
        </ul>
      </li>
    </ul>
  </section>
</template>
<script>
  import { Api } from '../service/api'
  export default {
    name: 'ServiceNav',
    data() {
      return {
        navList: [
          {
            id: 1,
            text: '首页',
            active: false,
            state: false,
            children: []
          }, {
            id: 2,
            text: 'SEO服务',
            active: false,
            state: false,
            children: [
              {
                id: 1,
                text: '快速排名',
                // pageUrl: '/dashboard/optimizeManagement/keywordManagement',
                pageUrl: '/dashboard/optimizeManagement/quickRanking',
                active: false
              },
              //   {
              //   id: 2,
              //   text: 'SEO优化',
              //   // pageUrl: '/index/result/seo',
              //   pageUrl: '/dashboard/optimizeManagement/SEOOptimize',
              //   active: false
              // },
                {
                id: 3,
                text: '积分优化',
                // pageUrl: '/index/result/list',
                pageUrl: '/dashboard/optimizeManagement/integrationOptimize',
                active: false
              }, {
                id: 4,
                text: '整站优化',
                pageUrl: '/dashboard/optimizeManagement/webOptimize',
                active: false
              },
            ]
          },
          //   {
          //   id: 3,
          //   text: '充值全返',
          //   active: false,
          //   state: false,
          //   children: []
          // },
            {
            id: 4,
            text: '城市合伙人',
            active: false,
            state: false,
            children: []
          }, {
            id: 5,
            text: '操作培训',
            active: false,
            state: false,
            children: []
          }, {
            id: 6,
            text: '服务内容',
            active: false,
            state: false,
            children: []
          }, {
            id: 7,
            text: '常见问题',
            active: false,
            state: false,
            children: []
          }, {
            id: 8,
            text: '平台介绍',
            active: false,
            state: false,
            children: []
          }, {
            id: 9,
            text: '联系我们',
            active: false,
            state: false,
            children: []
          }
        ]
      }
    },
    methods: {
      sleectService(item) {
        this.navList.map(value => {
          value.active = false;
          //if(item.id == value.id && item.id != 9 && item.id != 5 && item.id != 3 && item.id != 4 && item.id != 1 && item.id != 6 && item.id != 8) {
          //  value.active = true;
          //}
        })
        item.active = true;
      },
      hideChild(e) {
        this.navList.map(value => {
          value.active = false;
        })
      },
      selectDetail(item, child) {
        item.active = true;
        item.children.map(value => {
          value.active = false;
          if(value.id == child.id) {
            child.active = true;
          }

        })
      },
      gotoPage(child) {
        if(child.pageUrl){
          if(child.pageUrl.includes('index/articleList')){
            eventBus.$emit('getArticlePid', child.id)
          }

          this.$router.push({
            path: child.pageUrl
          })
        }
      },
      gotoNextPage(item) {
        //if(item.children.length > 0){
        //  item.state = !item.state;
        //  return
        //}
        if(item.text == '首页'){
          this.$router.push({
            path: '/'
          })
        }else if(item.text == '联系我们'){
          this.$router.push({
            path: '/index/aboutUs'
          })
        }else if(item.text == '操作培训'){
          this.$router.push({
            path: '/index/operationTraining'
          })
        }else if(item.text == '服务内容'){
          this.$router.push({
            path: '/index/addedService'
          })
        }else if(item.text == '充值全返'){
          this.$router.push({
            path: '/index/returnRecharge'
          })
        }else if(item.text == '城市合伙人'){
          this.$router.push({
            path: '/index/cityCompany'
          })
        }else if(item.text == '常见问题'){
            eventBus.$emit('articleDetail',16)
            this.$router.push({
                path: '/index/articleList/'+16
            })
        }else if(item.text == '平台介绍'){
          this.$router.push({
            path: '/index/platformIntroduce'
          })
        }
      },
      getArticleCategory (pid) {
        let  params = {

        }
        Api.getArticleCategory(params).then((res)=> {
          this.navList[5].children = []
          for(let i=0;i<res.data.data.length; i++){
            let child = {
              value: i+1,
              text: res.data.data[i].name,
              active: false,
              pid: res.data.data[i].pid,
              pageUrl: `/index/articleList/${res.data.data[i].id}`,
            }
            this.navList[5].children.push(child)
          }
        })
      }
    },
    mounted() {

      //this.getArticleCategory()
      eventBus.$on('hideServiceNav', () => {
        this.navList.map(value => {
          value.state = false;
        })
      })
    }
  }
</script>
<style scoped lang='scss'>
  section{
    padding: 0 2.5rem 16px;
    background: #101317;
    display: flex;
    color: rgba(255,255,255,0.6);
    .navList{
      display: flex;
      width: 100%;
      justify-content: space-between;
      .list{
        width: 100%;
        line-height: 36px;
        height: 36px;
        position: relative;
        left: 0;
        top: 0;
        span{
          padding: 10px 6px;
          position: relative;
          left: 0;
          top: 0;
          color: #B4B7C7;
          cursor: pointer;
          white-space: nowrap;
          &.active{
            color: #FC5F35;
            &:after{
              content: '';
              display: block;
              position: absolute;
              left: 0;
              bottom: 0;
              width: 100%;
              height: 3px;
              background: #FC5F35;
            }
          }
        }
        >ul{
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: 32px;
          z-index: 20;
          background: #44403f;
          padding: 4px 10px;
          width: 100%;
          li{
            line-height: 26px;
            cursor: pointer;
            font-size: 13px;
            white-space: nowrap;
            &.childActive{
              color: #FC5F35;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ServiceNav.vue